import Vue from 'vue'
import Vuex from 'vuex'


import { PackingListStore } from './PackingListTemplates'
import { AuthStore } from './Auth'
import { RuxStore } from './Rux'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    rux: RuxStore,
    packingListTemplate: PackingListStore,
    auth: AuthStore
  }
})
export function getDefaultStore () {
  return {
    modules: {
      rux: RuxStore,
      packingListTemplate: PackingListStore,
      auth: AuthStore
    }
  }
}
